import axios from 'axios';
import { apiRouter } from './../router/api-routing.js';
let CryptoJS = require("crypto-js")
import Vue from 'vue'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)


export function getHeaderToken(){
  var token = getDataToken()
  // var token_type = 'Bearer';
  // console.log('tokennn', token)
  // console.log('type', token.token_type)
  // console.log('access', token.access_token)
  return {
    headers: {
      'Authorization' : token.token_type +' '+ token.access_token,
      'Accept' :'application/json',
    }
  }
}

export function getRoleId(){
  let roleId = localStorage.getItem('role_id');
  // if (roleId){
  //   var encrypted = window.atob(roleId)
  //   var bytes  = CryptoJS.AES.decrypt(encrypted, process.env.SECRET_KEY);
  //   var plaintext = bytes.toString(CryptoJS.enc.Utf8);
  //   roleId = JSON.parse(plaintext)
  // }
  return roleId;
}

export function getSalesName(){
  let salesName = localStorage.getItem('fullname');
  // if (salesName){
  //   var encrypted = window.atob(salesName)
  //   var bytes  = CryptoJS.AES.decrypt(encrypted, process.env.SECRET_KEY);
  //   var plaintext = bytes.toString(CryptoJS.enc.Utf8);
  //   salesName = JSON.parse(plaintext)
  // }
  // JSON.parse(CryptoJS.AES.decrypt(window.atob(localStorage.getItem('fullname')), process.env.SECRET_KEY).toString(CryptoJS.enc.Utf8))
  return salesName;
}

export function isLoggedIn() {
  const idToken = getIdToken();
  const expired_token = isTokenExpired();
  const roleId = getRoleId();
  const salesName = getSalesName();
  if('' != idToken && expired_token === 0 && ''!=roleId && ''!=salesName){
    // var today = new Date();
    // var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds()
    // console.log('daatt', time+10h)
    //date.setDate(date.getDate() + 1);
    // Vue.cookies.set("TBM","GH1.1.1689020474.1484362313", "Thu, 19 Sep 2019 17:58:11 GMT ");
    // 30 day after, expire
    // this.$cookies.config('1m')
    return 1;
  }else{
    removeToken();
    removeRoleId();
    return 0;
  }
}

export function getDataToken(){
  let token = localStorage.getItem('tokenTBM')
  // let role_id = localStorage.getItem('role_id')
  // let role_name = localStorage.getItem('role_name')
  // let fullname = localStorage.getItem('fullname')

  //decrypt
  // if(token){
  //   var tokenEncrypted = window.atob(token)
  //   var bytes  = CryptoJS.AES.decrypt(tokenEncrypted, process.env.SECRET_KEY);
  //   var plaintext = bytes.toString(CryptoJS.enc.Utf8);
  //   token = JSON.parse(plaintext)
  // }
  token = JSON.parse(token)
  return token
  // return {'tokenTBM': token, 'role_id': role_id, 'role_name': role_name, 'fullname': fullname}
}

export function typeToken(){
  let token = getDataToken();
  let type_token = '';
  if(token){
    type_token = token.token_type;
  }
  return type_token;
}

export function getIdToken(){
    let token = getDataToken();
    let access_token = '';
    if(token){
      access_token = token.access_token;
    }
    return access_token;
}

export function isTokenExpired(){
  let token = getDataToken();
  let expired_token = '';
  let expired = 1;
  if(token){
    var now = new Date().getTime()/1000;
    return now < token.expires_in? 1:0;
    // expired_token = token.expired_token;
    // let d = new Date();
    // let month = '' + (d.getMonth() + 1);
    // let day = '' + d.getDate();
    // let year = d.getFullYear();
    // let hours = d.getHours();
    // let minutes = d.getMinutes();
    // let seconds = d.getSeconds();

    // if (month.length < 2) month = '0' + month;
    // if (day.length < 2) day = '0' + day;
    // if (hours.length < 2) hours = '0' + hours;
    // if (minutes.length < 2) minutes = '0' + minutes;
    // if (seconds,length < 2) seconds = '0' + seconds;
    // let date = year+'-'+month+'-'+day+' '+hours+':'+':'+minutes+':'+seconds;
    // if(expired_token >= date){
    //   expired = 0;
    // }

    // return expired;
  }

}

export function refreshToken(){
  let token = getDataToken();
  let refresh_token = '';
  if(token){
    refresh_token = token.refresh_token;
  }
  return refresh_token;
}

export function getRefreshToken(){
  let refresh_token = refreshToken();
  const formData = new FormData();
  formData.append('refresh_token', refresh_token);
  const header = {
      headers: {
        'Accept' :'application/json',
      }
  };

  axios.post(apiRouter().refresh_token, formData,header)
  .then( (response) => {
      localStorage.setItem('tokenTBM', JSON.stringify(response.data));
  })
  .catch((error) => {
    console.log(error);
  });
}

export function removeToken(){
  localStorage.removeItem('tokenTBM');
}

export function removeRoleId(){
  localStorage.removeItem('role_id');
}
